import React, { useContext, useEffect, useRef } from 'react';
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Regex from "../../../Utilities/Regex";
import { ChalanUpdateAndReturnContext } from "../ChalanUpdateAndReturnComponent";
import ChalanItemReturnCalc from "../Methods/ChalanItemReturnCalc";
import CommonToast from "../../../Utilities/CommonToast";
import { useDispatch } from "react-redux";
import ButtonLoader from "../../CommonComponent/ButtonLoader/ButtonLoader";
import CommonLoader from "../../../Utilities/CommonLoader";
import { chalanItemReturnAction, stockItemReturnAction } from "../../../Redux/Action/PurAction";
import FieldToText from "../../../Utilities/FieldToText";

function ChalanReturnForm({ is_stock_return }) {
    // hook
    const dispatch = useDispatch()
    const chalanItemReturnBtnRef = useRef()
    // getting data from context
    const {
        singleChalanItemForReturn,
        singleChalanForUpdate,
        setNewOnClickState,
        chalanGetForUdpateAndReturnOnSubmit,
        chalanGetFieldRef
    } = useContext(ChalanUpdateAndReturnContext)
    // hook form property
    const { register, handleSubmit, getValues, resetField, setValue, formState: { errors } } = useForm();
    // custom methods
    const chalanItemReturnCalc = new ChalanItemReturnCalc(getValues, setValue, resetField)

    // set default value lifecycle
    useEffect(() => {
        Object.keys(getValues()).map(fieldProps => {
            resetField(fieldProps)
            fieldProps != "unit_return_price" ? setValue(fieldProps, "") : setValue(fieldProps, (singleChalanItemForReturn.unit_pur_price) || "")

        })
        // set comma
        setComma()
    }, [singleChalanItemForReturn])
    // set comma
    const setComma = () => {
        let idForComma = ["return_total_price", "return_bonus_qty", "return_qty", "unit_return_price"]
        //set comma
        idForComma.map(id => {
            FieldToText.set([[id, getValues(id)]])
        })
    }

    // form submit
    const onSubmit = async data => {
        // making payload for return
        const payload = {
            data: {
                chalan_no: singleChalanForUpdate.chalan_no,
                chalan_id: singleChalanItemForReturn.chalan_id,
                chalan_item_id: singleChalanItemForReturn.id,
                return_qty: (data.return_qty),
                return_bonus_qty: (data.return_bonus_qty),
                return_total_price: data.return_total_price,
                remark: data.remark
            },
            chalanItemReturnBtnRef,
            setNewOnClickState,
            chalanGetForUdpateAndReturnOnSubmit,
            chalanGetFieldRef
        }

        // action dispatch
        if (is_stock_return == false) { // when challan item return
            Object.keys(singleChalanForUpdate).length != 0 ? dispatch(chalanItemReturnAction(payload)) : CommonToast.warning("Please select an item for return")
        } else { // when stock item return
            Object.keys(singleChalanForUpdate).length != 0 ? dispatch(stockItemReturnAction(payload)) : CommonToast.warning("Please select an item for return")
        }

    }
    return (
        <>

            <Form onChange={e => setComma()} onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md={4}>
                        {/*Product Name with style*/}
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Product name</Form.Label>
                            <Form.Control
                                defaultValue={singleChalanItemForReturn.cfg_product?.product_name || ""}
                                disabled={true}
                                type="text"
                                placeholder="product name"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        {/*category*/}
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Category</Form.Label>
                            <Form.Control
                                defaultValue={singleChalanItemForReturn.cfg_product?.cfg_category?.category_name || ""}
                                disabled={true}
                                type="text"
                                placeholder="category"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        {/*unit return price*/}
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Unit return price</Form.Label>
                            <span className="text-danger">
                                &nbsp;  {singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name && "in " + singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name}
                            </span>
                            <Form.Control
                                autocomplete={"off"}
                                disabled
                                type="text"
                                placeholder="unit return price"
                                className={errors.unit_return_price ? "is-invalid" : ""}
                                {...register("unit_return_price", {
                                    required: true,
                                    pattern: Regex.numeric(),
                                    onChange: event => {
                                        chalanItemReturnCalc.unitPriceOnChange()
                                    }
                                })}
                            />
                            {/*validation message*/}
                            {errors.unit_return_price && <span className="text-danger">
                                {errors.unit_return_price.type == "required" && "This field is required."}
                                {errors.unit_return_price.type == "pattern" && "Please provide a valid number"}
                            </span>}
                            {/*get comma*/}
                            {FieldToText.get("unit_return_price")}
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        {/*Return qty*/}
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Return Qty</Form.Label>
                            <span className="text-danger">
                                &nbsp;  {singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name && "in " + singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name}
                            </span>
                            <Form.Control
                                autocomplete={"off"}
                                type="text"
                                placeholder="return qty"
                                className={errors.return_qty ? "is-invalid" : ""}
                                {...register("return_qty", {
                                    required: true,
                                    max: singleChalanItemForReturn.qty_in_stock_unit,
                                    pattern: Regex.numeric(),
                                    onChange: event => {
                                        chalanItemReturnCalc.qtyOnChange()
                                    }
                                })}
                            />
                            {/*validation message*/}
                            {errors.return_qty && <span className="text-danger">
                                {errors.return_qty.type == "required" && "This field is required."}
                                {errors.return_qty.type == "pattern" && "Please provide a valid number"}
                                {errors.return_qty.type == "max" && "return Quantity can't be greater than purchase qty"}
                            </span>}
                            {/*get comma*/}
                            {FieldToText.get("return_qty")}
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        {/*bonus Return qty*/}
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Bonus return qty</Form.Label>
                            <span className="text-danger">
                                &nbsp;  {singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name && "in " + singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name}
                            </span>
                            <Form.Control
                                autocomplete={"off"}
                                type="text"
                                placeholder="bonus return qty"
                                className={errors.return_bonus_qty ? "is-invalid" : ""}
                                {...register("return_bonus_qty", {
                                    required: true,
                                    max: singleChalanItemForReturn.bonus_qty_in_stock_unit,
                                    pattern: Regex.numeric(),
                                    onChange: event => {
                                        chalanItemReturnCalc.bonusQtyOnChange()
                                    }
                                })}
                            />
                            {/*validation message*/}
                            {errors.return_bonus_qty && <span className="text-danger">
                                {errors.return_bonus_qty.type == "required" && "This field is required."}
                                {errors.return_bonus_qty.type == "pattern" && "Please provide a valid number"}
                                {errors.return_bonus_qty.type == "max" && "return Quantity can't be greater than purchase qty"}
                            </span>}
                            {/*get comma*/}
                            {FieldToText.get("return_bonus_qty")}
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        {/*Total return qty*/}
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Total return Qty</Form.Label>
                            <span className="text-danger">
                                &nbsp;  {singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name && "in " + singleChalanItemForReturn?.cfg_product?.stock_unit?.unit_name}
                            </span>
                            <Form.Control
                                disabled={true}
                                type="text"
                                placeholder="total return qty"
                                className={errors.total_return_qty ? "is-invalid" : ""}
                                {...register("total_return_qty", {
                                    required: true,
                                    pattern: Regex.numeric()
                                })}
                            />
                            {/*validation message*/}
                            {errors.total_return_qty && <span className="text-danger">
                                {errors.total_return_qty.type == "required" && "This field is required."}
                                {errors.total_return_qty.type == "pattern" && "Please provide a valid number"}
                            </span>}
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        {/*Total return price*/}
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Total return price</Form.Label>
                            <Form.Control
                                disabled
                                autocomplete={"off"}
                                type="text"
                                placeholder="total return price"
                                className={errors.return_total_price ? "is-invalid" : ""}
                                {...register("return_total_price", {
                                    required: true,
                                    max: singleChalanItemForReturn.total_pur_price,
                                    pattern: Regex.numeric(),
                                    onChange: event => {
                                        chalanItemReturnCalc.totalReturnPriceOnChange()
                                    }
                                })}
                            />
                            {/*validation message*/}
                            {errors.return_total_price && <span className="text-danger">
                                {errors.return_total_price.type == "required" && "This field is required."}
                                {errors.return_total_price.type == "pattern" && "Please provide a valid number"}
                                {errors.return_total_price.type == "max" && "Total return price can't be greater than total purchase price"}
                            </span>}
                            {/*get comma*/}
                            {FieldToText.get("return_total_price")}
                        </Form.Group>
                    </Col>

                    <Col md={8}>
                        {/*Remark*/}
                        <Form.Group className="mb-2" controlId="formBasicEmail">
                            <Form.Label>Remark</Form.Label>
                            <Form.Control
                                placeholder={'why you want to return this item?'}
                                as="textarea" rows={4}
                                className={errors.remark ? "is-invalid" : ""}
                                {...register("remark", {
                                    required: true,
                                })}
                            />
                            {/*validation message*/}
                            {errors.remark && <span className="text-danger">
                                {errors.remark.type == "required" && "This field is required."}
                            </span>}
                        </Form.Group>
                    </Col>
                </Row>

                <div className="text-end">
                    <Button ref={chalanItemReturnBtnRef} variant="danger" disabled={false} className="mt-2 "
                        type="submit">
                        Return
                        <ButtonLoader />
                    </Button>
                </div>
            </Form>
        </>
    );
}

export default ChalanReturnForm;